/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CancelResponseRequest = {
  responseId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const CancelResponseRequest$inboundSchema: z.ZodType<
  CancelResponseRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  response_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "response_id": "responseId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type CancelResponseRequest$Outbound = {
  response_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const CancelResponseRequest$outboundSchema: z.ZodType<
  CancelResponseRequest$Outbound,
  z.ZodTypeDef,
  CancelResponseRequest
> = z.object({
  responseId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    responseId: "response_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function cancelResponseRequestToJSON(
  cancelResponseRequest: CancelResponseRequest,
): string {
  return JSON.stringify(
    CancelResponseRequest$outboundSchema.parse(cancelResponseRequest),
  );
}
export function cancelResponseRequestFromJSON(
  jsonString: string,
): SafeParseResult<CancelResponseRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CancelResponseRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CancelResponseRequest' from JSON`,
  );
}
